import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { CardFooterBadge, classNames, FlexCenter, FlexColumn, NumberDisplay, TextLabel, Tooltip, tv } from "@opensea/ui-kit";
import { Stat0Filled } from "@opensea/ui-kit/icons";
import { useTranslations } from "use-intl";
import { RarityBadgeFragment } from "./RarityBadge.fragment";
const rarityBadgeVariants = tv({
  variants: {
    variant: {
      RARE: "text-rare",
      EPIC: "text-epic",
      LEGENDARY: "text-legendary",
      NONE: ""
    }
  }
});
export function RarityBadge(t0) {
  const $ = _c(20);
  const {
    item: itemKey,
    className
  } = t0;
  const t = useTranslations("wallet.RarityBadge");
  let T0;
  let T1;
  let getTopPercent;
  let t1;
  let t2;
  let t3;
  if ($[0] !== className || $[1] !== itemKey || $[2] !== t) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const item = readFragment(RarityBadgeFragment, itemKey);
      const category = item?.rarity?.category;
      if (!category) {
        t3 = null;
        break bb0;
      }
      if (category === "NONE") {
        t3 = null;
        break bb0;
      }
      getTopPercent = () => {
        if (category === "LEGENDARY") {
          return 1;
        }
        if (category === "EPIC") {
          return 10;
        }
        return 25;
      };
      T1 = Tooltip;
      t2 = item.rarity?.totalSupply && item.rarity.rank ? <FlexColumn className="gap-2"><FlexCenter className={classNames(rarityBadgeVariants({
          variant: category
        }), "gap-1")}><Stat0Filled size={20} /><TextLabel>{t("top")} {getTopPercent()}%</TextLabel></FlexCenter><TextLabel><NumberDisplay display="full" prefix="#" value={item.rarity.rank} />{" "}/ <NumberDisplay display="full" value={item.rarity.totalSupply} /></TextLabel></FlexColumn> : null;
      T0 = CardFooterBadge;
      t1 = classNames(rarityBadgeVariants({
        variant: category,
        className: "pl-0"
      }), className);
    }
    $[0] = className;
    $[1] = itemKey;
    $[2] = t;
    $[3] = T0;
    $[4] = T1;
    $[5] = getTopPercent;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    T0 = $[3];
    T1 = $[4];
    getTopPercent = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Stat0Filled size={20} />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = getTopPercent();
  let t6;
  if ($[10] !== t5) {
    t6 = <TextLabel>{t5}%</TextLabel>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== T0 || $[13] !== t1 || $[14] !== t6) {
    t7 = <T0 className={t1}>{t4}{t6}</T0>;
    $[12] = T0;
    $[13] = t1;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== T1 || $[17] !== t2 || $[18] !== t7) {
    t8 = <T1 content={t2}>{t7}</T1>;
    $[16] = T1;
    $[17] = t2;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}